// extracted by mini-css-extract-plugin
export var container = "_63-0";
export var fallback = "_63-5";
export var fallbackIcon = "_63-6";
export var hidden = "_63-2";
export var image = "_63-3";
export var loaded = "_63-4";
export var placeholder = "_63-1";